module.exports = __webpack_public_path__ + "static/home-staticLR-05c5aafbe3ea1b3fd92a95c250098408.jpg";